import SignatureCanvas from 'react-signature-canvas';
import { useRef, useState } from 'react';

const useSignature = () => {
  const [isEmpty, setIsEmpty] = useState(true);
  const signatureRef = useRef<SignatureCanvas>(null!);
  const [showPreviewMode, setShowPreviewMode] = useState(true);
  const clearPad = () => {
    setIsEmpty(true);
    signatureRef.current.clear();
  };

  const exitPreviewMode = () => {
    setShowPreviewMode(false);
  };
  const getImage = () => {
    return new Promise<Blob>((resolve) => {
      signatureRef.current
        .getCanvas()
        .toBlob((blob) => resolve(blob!), 'image/jpeg', 0.5);
    });
  };

  const onDrawingStop = () => {
    setIsEmpty(signatureRef.current.isEmpty());
  };

  return {
    signatureRef,
    clearPad,
    exitPreviewMode,
    getImage,
    onDrawingStop,
    isEmpty,
    showPreviewMode,
  };
};

export default useSignature;

export type UseSignatureReturn = ReturnType<typeof useSignature>;
